﻿import React, { useMemo } from 'react';
import { str_isEmpty } from '@Util/Utils';
import {
    Select_With_Label_Props,
    Select_Option
} from '@Util/Types';

export default function Select_With_Label({
    id,
    className,
    error,
    label,
    value,
    onChange,
    options
}: Select_With_Label_Props): JSX.Element {

    const elementClass = useMemo(() => {
        let classStr = "Form_Row";

        if (!str_isEmpty(className)) {
            classStr += ` ${className}`;
        }

        if (error) {
            classStr += " Form_Row--Error";
        }

        return classStr;
    }, [className, error]);

    return (
        <div className={elementClass}>
            {label && <label htmlFor={id}>{label}</label>}
            <select
                id={id}
                name={id}
                value={value}
                onChange={onChange}
            >
                {options.map((option: Select_Option): JSX.Element =>
                    <option key={option.value} value={option.value}>{option.text}</option>
                )}
            </select>
        </div>
    );
}